<div class="align-with-nav">
    <h1 class="title-heading">Articles</h1>
    <ul>
        <li *ngFor="let article of articles"><a [routerLink]='article.link'>{{ article.title }} - {{ article.date }}</a><p>{{ article.description }}</p></li>
    </ul>
</div>